import React from 'react';
import { Modal, ModalOverlay, ModalContent, ModalHeader, ModalCloseButton, ModalBody } from "@chakra-ui/react";

export function ModalComponent({isOpen, onClose, size="2xl", title, children})
{
    return(
  <Modal isOpen={isOpen} onClose={onClose} size={size}>
    <ModalOverlay/>
    <ModalContent>
      <ModalHeader className="flex justify-between items-center mt-2 mx-2">
        <div>{title}</div>
        <ModalCloseButton style={{position: "static"}}/>
      </ModalHeader>
      <ModalBody className="mb-4">
        {children}
      </ModalBody>
    </ModalContent>
  </Modal>
    );
}
